if (!customElements.get('comparison-table-scroll')) {
  customElements.define(
    'comparison-table-scroll',
    class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('role') || !('ResizeObserver' in window)) return;
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this);
        if (this.firstElementChild) this.observer.observe(this.firstElementChild);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      update() {
        if (this.scrollWidth > this.clientWidth) {
          this.setAttribute('tabindex', '0');
        } else if (document.activeElement !== this) {
          this.removeAttribute('tabindex');
        }
      }
    }
  );
}
